import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps, GridFilterCellProps } from '@progress/kendo-react-grid'
import {
  CheckStates,
  PspWdCheckPaymentOptionsDto,
  WalletPaymentProviderFilterKey,
  WalletPaymentProviderKey,
} from 'api/Wallet/Types/FullPaymentProviderDto'
import { inputFilterCell, selectFilterCell } from 'components/Filter/FilterCell'
import { Link } from 'components/Link'

import { WalletType } from '../../../../../api/Wallet/Types/Wallet'
import { links } from '../../../../../utils/featureToggles'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const CheckStateFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const items = CheckStates.map(({ id, name }) => ({
    id: id.toString(),
    label: name,
    value: id.toString(),
  }))
  return selectFilterCell({
    items,
    options: {
      operator: '==',
    },
  })(props)
}

const IBCheckStateFilterCell: React.FC<GridFilterCellProps> = (props) => {
  const items = CheckStates.map(({ id, name }) => ({
    id: id.toString(),
    label: name,
    value: id.toString(),
  }))

  return selectFilterCell({
    items,
    options: {
      operator: '==',
    },
  })(props)
}

export const paymentControlsPSPCheckStateColumn: GridColumn[] = [
  {
    title: 'Name',
    field: WalletPaymentProviderKey.name,
    filterCell: inputFilterCell({
      options: {
        operator: 'like',
      },
    }),
    cell: (props: GridCellProps): JSX.Element => {
      const { paymentProvider } = props.dataItem

      if (!paymentProvider.id) {
        return <td />
      }

      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(
                links.administrationPaymentControlsPSPCheckState.detailsUrl as string,
                {
                  id: paymentProvider.id,
                }
              ),
            }}
          >
            {paymentProvider.name}
          </Link>
        </td>
      )
    },
    show: true,
    filterable: true,
  },
  {
    title: 'FX/CFD Check State',
    filterCell: CheckStateFilterCell,
    field: WalletPaymentProviderFilterKey.CheckStateFx,
    cell: (props: GridCellProps): JSX.Element => {
      const data: PspWdCheckPaymentOptionsDto = props.dataItem
      const fxCFDWalletType = data.walletTypeOptions.find(
        (x) => x.walletType.id === WalletType.FXCFD
      )
      if (!fxCFDWalletType) {
        return <td />
      }
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          {fxCFDWalletType.checkState.name}
        </td>
      )
    },
    show: true,
    filterable: true,
  },
  {
    title: 'IB Check State',
    filterCell: IBCheckStateFilterCell,
    field: WalletPaymentProviderFilterKey.CheckStateIb,
    cell: (props: GridCellProps): JSX.Element => {
      const data: PspWdCheckPaymentOptionsDto = props.dataItem
      const iBWalletType = data.walletTypeOptions.find(
        (x) => x.walletType.id === WalletType.IB_FXCFD
      )
      if (!iBWalletType) {
        return <td />
      }
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          {iBWalletType.checkState.name}
        </td>
      )
    },
    show: true,
    filterable: true,
  },
]
